import groq from "groq";

export const RPNPageQuery = groq`
*[_type == "rpn-page"][0]{
  _type,
  _id,
  _createdAt,
  _updatedAt,
  _rev,
  title,
  description,
  OpenGraphImage{
    asset->{
      _id,
      url,
      metadata{ dimensions }
    }
  },
  leadFormTitle,
  leadFormSubtitle,
  rating,
  
  phoneCtaText,
  phoneNumber,
  leadFormCtaLabel,

  benefitsSectionTitle,
  benefitsSectionItems[]{
    _key,
    title,
    content,
    icon
  },

  descriptionOfCareSectionTitle,
  descriptionOfCareSectionSubtitle,
  descriptionOfCareList[]{
    _key,
    title,
    content,
    services,
    image{
      asset->{
        _id,
        url,
        metadata{ dimensions }
      },
      alt
    }
  },

  resourcesSectionTitle,
  resourceList[]{
    _key,
    itemTitle,
    description,
    resourceFile {
      asset->{
        _id,
        url,
        originalFilename,
        mimeType,
        size
      }
    }
  },

  testimonialsSectionTitle,
  testimonialsList[]{
    _key,
    name,
    text
  }
}
`;
